<nz-page-header nzTitle="Consumo de materia prima"></nz-page-header>

<nz-tabset>

    <!-- ══════════════════════════════════════════════════════════
         Tab 1 → Por Lote / Paquete (existing)
    ═══════════════════════════════════════════════════════════════ -->
    <nz-tab nzTitle="Por Lote / Paquete">

        <div style="display:flex; align-items:center; gap:8px; padding: 16px 0 8px;">
            <nz-input-group [nzSuffix]="searchIcon" style="width: 320px;">
                <input
                    nz-input
                    placeholder="Número de lote o paquete..."
                    [(ngModel)]="searchValue"
                    (keyup.enter)="onSearch()"
                />
            </nz-input-group>
            <ng-template #searchIcon>
                <span nz-icon nzType="search" style="cursor:pointer;" (click)="onSearch()"></span>
            </ng-template>
            <button nz-button nzType="primary" (click)="onSearch()" [nzLoading]="isLoading">
                Buscar
            </button>
        </div>

        <nz-spin [nzSpinning]="isLoading">

            @if (rows.length > 0) {
            <nz-divider></nz-divider>

            @if (headerTitle) {
            <div style="margin-bottom:8px;">
                <strong>{{ headerTitle }}</strong>
                @if (headerSubtitle) { <span style="color:#888; margin-left:8px;">{{ headerSubtitle }}</span> }
            </div>
            }

            <!-- Totals summary -->
            <div style="display: flex; gap: 32px; margin-bottom: 16px; flex-wrap: wrap;">
                <div>
                    <span style="color: #888; font-size: 12px;">Sensor (rawQuantity)</span>
                    <div style="font-size: 20px; font-weight: 600;">{{ totalRaw | number:'1.3-3' }}</div>
                </div>
                <div>
                    <span style="color: #888; font-size: 12px;">Materia prima (usedQuantity)</span>
                    <div style="font-size: 20px; font-weight: 600;">{{ totalUsed | number:'1.3-3' }}</div>
                </div>
                <div>
                    <span style="color: #888; font-size: 12px;">Estimado (estimatedQuantity)</span>
                    <div style="font-size: 20px; font-weight: 600;">{{ totalEstimated | number:'1.3-3' }}</div>
                </div>
                <div>
                    <span style="color: #888; font-size: 12px;">Diferencia (used - estimado)</span>
                    <div style="font-size: 20px; font-weight: 600;" [style.color]="totalDifference > 0 ? '#cf1322' : totalDifference < 0 ? '#389e0d' : 'inherit'">
                        {{ totalDifference | number:'1.3-3' }}
                    </div>
                </div>
            </div>

            <nz-table
                #batchTable
                [nzData]="rows"
                [nzPageSize]="50"
                [nzShowSizeChanger]="true"
                [nzPageSizeOptions]="[20, 50, 100]"
                nzSize="small"
            >
                <thead>
                    <tr>
                        <th>Lote</th>
                        <th>Artículo</th>
                        <th>Paquete / Bobina</th>
                        <th>Tipo paquete</th>
                        <th>Orden de producción</th>
                        <th nzAlign="right">Sensor (rawQ)</th>
                        <th nzAlign="right">Mat. Prima (usedQ)</th>
                        <th nzAlign="right">Estimado (estQ)</th>
                        <th nzAlign="right">Diferencia</th>
                    </tr>
                </thead>
                <tbody>
                    @for (row of batchTable.data; track row.id) {
                    <tr>
                        <td>{{ row.articleBatch?.batchNumber ?? '—' }}</td>
                        <td>{{ row.articleBatch?.article?.name ?? '—' }}</td>
                        <td>{{ getPackagingLabel(row) }}</td>
                        <td>{{ row.usedPackaging?.packagingType?.name ?? '—' }}</td>
                        <td>
                            @if (row.productionOrder) {
                                <span>
                                    {{ row.productionOrder.description }}
                                    @if (row.productionOrder.externalId) {
                                        <span style="color:#888"> (#{{ row.productionOrder.externalId }})</span>
                                    }
                                </span>
                            } @else { <span>—</span> }
                        </td>
                        <td nzAlign="right">{{ row.rawQuantity | number:'1.3-3' }}</td>
                        <td nzAlign="right">{{ row.usedQuantity | number:'1.3-3' }}</td>
                        <td nzAlign="right">{{ row.estimatedQuantity | number:'1.3-3' }}</td>
                        <td nzAlign="right">
                            <nz-tag [nzColor]="getDifferenceColor(row.difference)">
                                {{ row.difference | number:'1.3-3' }}
                            </nz-tag>
                        </td>
                    </tr>
                    }
                </tbody>
            </nz-table>
            }

            @if (!isLoading && rows.length === 0 && resolveResult) {
            <div style="text-align: center; padding: 40px; color: #888;">
                No hay registros de consumo para este lote/paquete.
            </div>
            }

        </nz-spin>

    </nz-tab>

    <!-- ══════════════════════════════════════════════════════════
         Tab 2 → Por Orden de Producción
    ═══════════════════════════════════════════════════════════════ -->
    <nz-tab nzTitle="Por Orden de Producción">

        <div style="display:flex; align-items:center; gap:8px; padding: 16px 0 8px;">
            <nz-input-group [nzSuffix]="orderSearchIcon" style="width: 320px;">
                <input
                    nz-input
                    placeholder="Número o descripción de orden..."
                    [(ngModel)]="orderSearchValue"
                    (keyup.enter)="onOrderSearch()"
                />
            </nz-input-group>
            <ng-template #orderSearchIcon>
                <span nz-icon nzType="search" style="cursor:pointer;" (click)="onOrderSearch()"></span>
            </ng-template>
            <button nz-button nzType="primary" (click)="onOrderSearch()" [nzLoading]="isLoadingOrder">
                Buscar
            </button>
            @if (orderRows.length > 0) {
            <button
                nz-button
                nzType="default"
                nzDanger
                (click)="recalcularOrden()"
                [nzLoading]="isRecalculating"
                [disabled]="isLoadingOrder"
            >
                <span nz-icon nzType="reload"></span>
                Recalcular
            </button>
            }
        </div>

        <nz-spin [nzSpinning]="isLoadingOrder">

            @if (orderRows.length > 0) {
            <nz-divider></nz-divider>

            @if (orderHeaderTitle) {
            <div style="margin-bottom:8px;">
                <strong>Orden: {{ orderHeaderTitle }}</strong>
            </div>
            }

            @if (unloadedMaterialNames.length > 0) {
            <nz-alert
                nzType="warning"
                nzShowIcon
                [nzMessage]="unloadedWarningTpl"
                style="margin-bottom: 16px;"
            ></nz-alert>
            <ng-template #unloadedWarningTpl>
                <strong>Materias primas no cargadas en máquina.</strong>
                El operario arrancó la orden sin cargar las siguientes materias primas, por lo que el estimado no se puede calcular correctamente:
                <ul style="margin: 4px 0 0 16px; padding: 0;">
                    @for (name of unloadedMaterialNames; track name) {
                    <li>{{ name }}</li>
                    }
                </ul>
            </ng-template>
            }

            <!-- Totals summary -->
            <div style="display: flex; gap: 32px; margin-bottom: 16px; flex-wrap: wrap;">
                <div>
                    <span style="color: #888; font-size: 12px;">Sensor (rawQuantity)</span>
                    <div style="font-size: 20px; font-weight: 600;">{{ totalOrderRaw | number:'1.3-3' }}</div>
                </div>
                <div>
                    <span style="color: #888; font-size: 12px;">Materia prima (usedQuantity)</span>
                    <div style="font-size: 20px; font-weight: 600;">{{ totalOrderUsed | number:'1.3-3' }}</div>
                </div>
                <div>
                    <span style="color: #888; font-size: 12px;">Estimado (estimatedQuantity)</span>
                    <div style="font-size: 20px; font-weight: 600;">{{ totalOrderEstimated | number:'1.3-3' }}</div>
                </div>
                <div>
                    <span style="color: #888; font-size: 12px;">Diferencia (used - estimado)</span>
                    <div style="font-size: 20px; font-weight: 600;" [style.color]="totalOrderDifference > 0 ? '#cf1322' : totalOrderDifference < 0 ? '#389e0d' : 'inherit'">
                        {{ totalOrderDifference | number:'1.3-3' }}
                    </div>
                </div>
                <div style="border-left: 2px solid #d9d9d9; padding-left: 32px;">
                    <span style="color: #888; font-size: 12px;">Uds. usuario (paquetes)</span>
                    <div style="font-size: 20px; font-weight: 600;">{{ totalOrderPackagingQty | number:'1.0-0' }}</div>
                </div>
            </div>

            <nz-table
                #orderTable
                [nzData]="orderRows"
                [nzPageSize]="50"
                [nzShowSizeChanger]="true"
                [nzPageSizeOptions]="[20, 50, 100]"
                nzSize="small"
            >
                <thead>
                    <tr>
                        <th>Lote</th>
                        <th>Artículo</th>
                        <th>Capa</th>
                        <th>Paquete / Bobina</th>
                        <th>Tipo paquete</th>
                        <th nzAlign="right">Sensor (rawQ)</th>
                        <th nzAlign="right">Metros sensor</th>
                        <th nzAlign="right">g/ml (origen)</th>
                        <th nzAlign="right">Motivo ancho</th>
                        <th nzAlign="right">Medida corte</th>
                        <th nzAlign="right">Mat. Prima (usedQ)</th>
                        <th nzAlign="right">Uds. usuario</th>
                        <th nzAlign="right">Estimado (estQ)</th>
                        <th nzAlign="right">Diferencia</th>
                    </tr>
                </thead>
                <tbody>
                    @for (row of orderTable.data; track row.id) {
                    <tr>
                        <td>{{ row.articleBatch?.batchNumber ?? '—' }}</td>
                        <td>{{ row.articleBatch?.article?.name ?? '—' }}</td>
                        <td>{{ row.capaLabel ?? '—' }}</td>
                        <td>{{ getPackagingLabel(row) }}</td>
                        <td>{{ row.usedPackaging?.packagingType?.name ?? '—' }}</td>
                        <td nzAlign="right">{{ row.rawQuantity | number:'1.3-3' }}</td>
                        <td nzAlign="right">{{ getSensorMeters(row) }}</td>
                        <td nzAlign="right">{{ row.gramsMl != null ? (row.gramsMl | number:'1.3-3') : '—' }}</td>
                        <td nzAlign="right">{{ row.motivoAncho != null ? (row.motivoAncho | number:'1.0-0') : '—' }}</td>
                        <td nzAlign="right">{{ row.medidaCorte != null ? (row.medidaCorte | number:'1.0-0') : '—' }}</td>
                        <td nzAlign="right">{{ row.usedQuantity | number:'1.3-3' }}</td>
                        <td nzAlign="right">{{ row.packagingQuantitySum | number:'1.0-0' }}</td>
                        <td nzAlign="right">
                            @if (row.alternativeEstimatedQuantity != null) {
                            <span nz-tooltip [nzTooltipTitle]="'Estimado original: ' + (row.estimatedQuantity | number:'1.3-3') + ' — Calculado en base a uds. usuario'">
                                <nz-tag nzColor="orange">
                                    <span nz-icon nzType="calculator" nzTheme="outline"></span>
                                    {{ row.alternativeEstimatedQuantity | number:'1.3-3' }}
                                </nz-tag>
                            </span>
                            } @else if (row.linkedPackagingsCount != null && row.linkedPackagingsCount <= 1 && row.rawQuantity > 0 && unloadedMaterialNames.length > 0) {
                            <nz-tag nzColor="warning">
                                <span nz-icon nzType="warning" nzTheme="outline"></span>
                                {{ row.estimatedQuantity | number:'1.3-3' }}
                            </nz-tag>
                            } @else {
                            {{ row.estimatedQuantity | number:'1.3-3' }}
                            }
                        </td>
                        <td nzAlign="right">
                            <nz-tag [nzColor]="getDifferenceColor(row.difference)">
                                {{ row.difference | number:'1.3-3' }}
                            </nz-tag>
                        </td>
                    </tr>
                    }
                </tbody>
            </nz-table>
            }

            @if (!isLoadingOrder && orderRows.length === 0 && orderSearchDone) {
            <div style="text-align: center; padding: 40px; color: #888;">
                No hay registros de consumo para esta orden.
            </div>
            }

        </nz-spin>

    </nz-tab>

</nz-tabset>

<!-- Ambiguous batch/packaging selection modal -->
<nz-modal
    [(nzVisible)]="isAmbiguousModalVisible"
    nzTitle="Se encontraron varios resultados"
    [nzFooter]="null"
    (nzOnCancel)="isAmbiguousModalVisible = false"
>
    <ng-container *nzModalContent>
        <p style="margin-bottom: 12px;">Hay más de un artículo con ese número. Selecciona el que quieres consultar:</p>
        <nz-table [nzData]="candidates" [nzShowPagination]="false" nzSize="small">
            <thead>
                <tr>
                    <th>Tipo</th>
                    <th>Número</th>
                    <th>Artículo</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (c of candidates; track c.id) {
                <tr>
                    <td>
                        <nz-tag [nzColor]="c.entityType === 'batch' ? 'blue' : 'purple'">
                            {{ c.entityType === 'batch' ? 'Lote' : 'Paquete' }}
                        </nz-tag>
                    </td>
                    <td>{{ c.batchNumber }}</td>
                    <td>{{ c.articleName }}</td>
                    <td>
                        <button nz-button nzType="primary" nzSize="small" (click)="onCandidateSelected(c)">
                            Ver consumo
                        </button>
                    </td>
                </tr>
                }
            </tbody>
        </nz-table>
    </ng-container>
</nz-modal>

<!-- Order selection modal (multiple matches) -->
<nz-modal
    [(nzVisible)]="isOrderSelectModalVisible"
    nzTitle="Varias órdenes encontradas"
    [nzFooter]="null"
    (nzOnCancel)="isOrderSelectModalVisible = false"
>
    <ng-container *nzModalContent>
        <p style="margin-bottom: 12px;">Selecciona la orden que quieres consultar:</p>
        <nz-table [nzData]="orderMatches" [nzShowPagination]="false" nzSize="small">
            <thead>
                <tr>
                    <th>Nº externo</th>
                    <th>Descripción</th>
                    <th>Referencia</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (o of orderMatches; track o.id) {
                <tr>
                    <td>{{ o.externalId ?? '—' }}</td>
                    <td>{{ o.description }}</td>
                    <td>{{ o.reference ?? '—' }}</td>
                    <td>
                        <button nz-button nzType="primary" nzSize="small" (click)="onOrderSelected(o)">
                            Ver consumo
                        </button>
                    </td>
                </tr>
                }
            </tbody>
        </nz-table>
    </ng-container>
</nz-modal>

